import React, { useMemo } from "react";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { useLibraryUIContext } from "../../LibraryUIContext";
import { initialFilter } from "../../LibraryUIHelpers";
import ReactSelect, { components } from "react-select";
import {
  IS_ACTIVE,
  ORGANIZATION_STATUS_OPTION
} from "../../../../../../config/helper";

const prepareFilter = (queryParams, values) => {
  const { name, description } = values;
  const newQueryParams = { ...queryParams };
  const filter = {};

  //add to Object filter
  filter.name = name ?? "";
  filter.description = description ?? "";
  newQueryParams.filter = filter;
  return newQueryParams;
};

export const LibraryFilter = ({ listLoading }) => {
  // Library UI Context
  const libraryUIContext = useLibraryUIContext();
  const libraryUIProps = useMemo(() => {
    return {
      setQueryParams: libraryUIContext.setQueryParams,
      queryParams: libraryUIContext.queryParams,
      filterType: libraryUIContext.filterType
    };
  }, [libraryUIContext]);

  const applyFilter = values => {
    const newQueryParams = prepareFilter(libraryUIProps.queryParams, values);
    if (!isEqual(newQueryParams, libraryUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      libraryUIProps.setQueryParams(newQueryParams);
    }
  };

  return (
    <Formik
      initialValues={initialFilter.filter}
      onSubmit={values => {
        applyFilter(values);
      }}
    >
      {({ values, handleSubmit, handleBlur, setFieldValue }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
            <div className="col-lg-4">
              <label htmlFor="name">Nama</label>
              <input
                type="text"
                className="form-control"
                name="name"
                placeholder="Nama Folder"
                onBlur={handleBlur}
                value={values.name}
                onChange={e => {
                  setFieldValue("name", e.target.value);
                }}
              />
            </div>
            <div className="col-lg-4">
              <label htmlFor="name">Deskripsi</label>
              <textarea
                className="form-control"
                name="description"
                placeholder="Deskripsi.."
                onBlur={handleBlur}
                value={values.description}
                onChange={e => {
                  setFieldValue("description", e.target.value);
                }}
              />
            </div>
          </div>
          <div className="form-group row">
            <div className="col">
              <button
                className="btn btn-warning float-right"
                onClick={handleSubmit}
              >
                Terapkan
              </button>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
};
